var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      [
        _c(
          "v-flex",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            attrs: { xs3: "", md3: "" }
          },
          [
            _c(
              "v-tooltip",
              { attrs: { bottom: "" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      slot: "activator",
                      large: "",
                      dark: "",
                      color: "#a358c8",
                      href:
                        "https://drive.economiayfinanzas.gob.bo/index.php/s/fppNJkj8RNAn4Qa",
                      target: "_blank"
                    },
                    slot: "activator"
                  },
                  [
                    _c("v-icon", [_vm._v("videocam")]),
                    _vm._v(" VIDEO TUTORIALES\n      ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Ver videotutoriales del sistema de RRHH")])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("v-flex", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          attrs: { xs9: "", md9: "" }
        }),
        _vm._v(" "),
        _c(
          "v-flex",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            attrs: { xs2: "", md4: "" }
          },
          [
            _c("h5", { attrs: { "class:titulo_qr": "" } }, [
              _vm._v(" QR para descargar la aplicación móvil")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "v-flex",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            attrs: { xs2: "", md4: "" }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/QR-SIAP.jpg"),
                alt: "",
                height: "170"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "v-flex",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            attrs: { xs4: "", md6: "" }
          },
          [_c("h5", { attrs: { "class:titulo_qr": "" } }, [_vm._v("V.1.1 ")])]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "login-container" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "v-card",
          { staticClass: "login-form" },
          [
            _c(
              "v-form",
              {
                ref: "form",
                attrs: { "lazy-validation": "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.valid,
                  callback: function($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid"
                }
              },
              [
                _c(
                  "v-card-title",
                  { attrs: { "primary-title": "" } },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("login.title")))]),
                    _vm._v(" "),
                    _c(
                      "v-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "username",
                                    label: _vm.$t("login.user"),
                                    id: "username",
                                    "append-icon": "person",
                                    autofocus: "",
                                    maxlength: "25",
                                    rules: _vm.$validate(["required"]),
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.form.username,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "username", $$v)
                                    },
                                    expression: "form.username"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "password",
                                    label: _vm.$t("login.password"),
                                    id: "password",
                                    "append-icon": _vm.getIcon,
                                    type: _vm.hidePass ? "password" : "text",
                                    maxlength: "100",
                                    rules: _vm.$validate(["required"]),
                                    required: ""
                                  },
                                  on: { "click:append": _vm.changeIcon },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "password", $$v)
                                    },
                                    expression: "form.password"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-card-actions",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          block: "",
                          large: "",
                          disabled: !_vm.valid,
                          type: "submit"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("login.login")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-card-title",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ]
                  },
                  [
                    _c(
                      "v-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "v-layout",
                          { staticClass: "login-options", attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs5: "" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.$t("login.rememberMe"),
                                    color: "primary"
                                  },
                                  model: {
                                    value: _vm.remember,
                                    callback: function($$v) {
                                      _vm.remember = $$v
                                    },
                                    expression: "remember"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs7: "" } }, [
                              _c("div", { staticClass: "text-xs-right" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.goToPasswordRecovery()
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", [_vm._v("lock_outline")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("login.forgotPass")) +
                                        "\n                  "
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-xs-center mt-3" },
          [
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { to: "/password-recovery" }
              },
              [_vm._v("Restablecer ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { to: "/loginlock" }
              },
              [_vm._v("Login Lock")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { to: "/login-nit" }
              },
              [_vm._v("Login NIT")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { to: "/login-ciudadania" }
              },
              [_vm._v("Login Ciudadania")]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "login-lang" }, [_c("app-lang")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-app" }, [
      _c("h2", [_vm._v("SAP")]),
      _vm._v(" "),
      _c("h1", [_vm._v("Sistema de Administración de Personal")]),
      _vm._v(" "),
      _c("h4", [_vm._v("Administracion de Servicios Portuarios - Bolivia")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf53641c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf53641c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/auth/Login.vue
// module id = null
// module chunks = 